import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { CanActivate } from "@angular/router";
import { LoginService } from "./services/login.service";
import { LoggerService } from "./services/logger.service";

@Injectable({ providedIn: "root" })
export class CanActivateViaAuthGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router, private logger: LoggerService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.loginService.userValue;
    if (user) {
      this.logger.log("estas logueado");
      // authorised so return true
      return true;
    }

    this.logger.log("No estás logueado");
    this.router.navigate(["/login"], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
